<cm-files-list *ngIf="showFilesList"
               class="upload-list"
               [files]="files"
               [showControls]="true"
               [maxSize]="maxSize"
               [allowedTypes]="allowedTypes"
               [compact]="compact"
               (removeFile)="onFileRemove($event)">
</cm-files-list>
<cm-file-input *ngIf="isMultipleFiles || !files?.length" [allowedTypes]="allowedTypes | fileTypes" (change)="onFilesSelect($event)" [isMultipleFiles]="isMultipleFiles"></cm-file-input>
